(function () {
  'use strict';

  function update(root, variantId) {
    var dataElement = root.querySelector('[data-chd-variant-material-data]');
    if (!dataElement) return;

    var facts;
    try {
      facts = JSON.parse(dataElement.textContent || '{}')[String(variantId)] || {};
    } catch (error) {
      return;
    }

    var hasFacts = false;
    ['material', 'lacquer', 'patina'].forEach(function (key) {
      var value = facts[key] || '';
      var row = root.querySelector('[data-chd-variant-material-row="' + key + '"]');
      var output = root.querySelector('[data-chd-variant-material-value="' + key + '"]');

      if (row) row.hidden = !value;
      if (output) output.textContent = value;
      if (value) hasFacts = true;
    });

    root.hidden = !hasFacts;

    var guide = root.querySelector('[data-chd-variant-material-guide]');
    var maintenance = root.querySelector('[data-chd-variant-material-value="maintenance"]');
    var hasMaintenance = Boolean(facts.maintenance);
    if (guide) {
      guide.hidden = !hasMaintenance;
      if (!hasMaintenance) guide.open = false;
    }
    if (maintenance) maintenance.textContent = facts.maintenance || '';
  }

  document.addEventListener('variant:changed', function (event) {
    var variant = event.detail && event.detail.variant;
    if (!variant || !event.target || !event.target.querySelectorAll) return;

    event.target.querySelectorAll('[data-chd-variant-material-details]').forEach(function (root) {
      update(root, variant.id);
    });
  });
})();
